import { RulesInfoDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
const renderRulesInfoDialog = mountDialogUIReactComponent(RulesInfoDialog);
export function showRulesInfoDialog(isTournamentRoom = false) {
    renderRulesInfoDialog({
        isTournamentRoom: isTournamentRoom,
        isStoreDisabled: UIUtilsEjsVariables.shouldHideStoreOnMobile
    });
}
